import React, { useState } from 'react';
import { ClipboardList, Sliders } from 'lucide-react';

import NulosRegistro from './NulosRegistro';
import NulosControle from './NulosControle';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

// =====================================================================
// FINANCEIRO — Nulos em Progresso: a CASCA do sub-módulo.
//
// Um card só no hub do Financeiro, com as duas telas em abas internas
// (Registrar · Controle) — o padrão dos vizinhos `FinanceiroEstorno.js` e
// `FinanceiroPettyCash.js`.
//
// ⚠️ VEIO DO MÓDULO AUDITORIA em 2026-08-28, no mesmo dia em que nasceu. A
//    Auditoria não perdeu a tela: o perfil `Auditoria` alcança o Financeiro e
//    segue lendo a rede inteira (e cancelando registro errado).
//
// ⚠️ Nasceu como DOIS cards no hub (28/08) e virou um no mesmo dia, a pedido da
//    Julia. A troca não é cosmética: as duas telas são o mesmo assunto, e como
//    card separado o hub anunciava dois módulos onde há um — além de o caminho
//    "registrei, quero ver na lista" ter de sair do sub-módulo e voltar pelo hub.
//
// ⚠️ `Auditoria` e `Financeiro` são SOMENTE LEITURA aqui: eles conferem, não
//    declaram — quem declara operou o POS. A aba de registro nem aparece, e a
//    entrada deles é o Controle. **Isto é UX** — quem barra a escrita é o
//    `authorizeRoles` do `server-nulos.js`, e a tela de registro também se recusa
//    a desenhar o formulário se a API disser que a pessoa não registra
//    (`GET /opcoes` › `podeRegistrar`).
// =====================================================================

// Paleta do módulo FINANCEIRO (verde-petróleo) — ver nota no NulosRegistro.js.
const COR = '#0d7a74';
const COR_FORTE = '#115e59';
const COR_FUNDO = '#f0fdfa';

const Nulos = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // ⚠️ Traduzido no módulo: `Diretoria Op` responde como `Diretoria` aqui — e
    //    apenas aqui. Sem o módulo no argumento, `Marketing` viraria Diretoria em
    //    telas onde ela não entra.
    const userRole = perfilNoModulo(user?.perfil, 'financeiro') || '';

    // ⚠️ LISTA, não comparação com um nome: `Financeiro` entrou junto com a
    //    mudança de módulo (28/08) e também não registra. Com o `===` de antes, ele
    //    abriria na aba de Registrar e levaria 403 ao enviar — erro no fim de um
    //    formulário preenchido, que é o pior lugar para descobrir a permissão.
    const PERFIS_SO_LEITURA = ['Auditoria', 'Financeiro'];
    const somenteLeitura = PERFIS_SO_LEITURA.includes(userRole);

    const [aba, setAba] = useState(somenteLeitura ? 'controle' : 'registrar');

    const estiloAba = (ativa) => ({
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px',
        backgroundColor: ativa ? COR_FUNDO : 'transparent',
        color: ativa ? COR_FORTE : '#64748b',
        border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
        transition: 'all 0.2s', fontSize: 14,
        boxShadow: ativa ? `inset 0 -2px 0 ${COR}` : 'none',
    });

    const conteudo = () => {
        if (somenteLeitura || aba === 'controle') return <NulosControle />;
        // O caminho curto da confirmação: "registrei, quero ver na lista" troca de
        // aba aqui dentro, sem passar pelo hub.
        return <NulosRegistro onIrParaControle={() => setAba('controle')} />;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            {/* SUB-MENU DO MÓDULO DE NULOS */}
            <div style={{
                display: 'flex', flexWrap: 'wrap', gap: 12,
                borderBottom: '1px solid #e2e8f0', paddingBottom: 16,
            }}>
                {!somenteLeitura && (
                    <button onClick={() => setAba('registrar')} style={estiloAba(aba === 'registrar')}>
                        <ClipboardList size={18} /> Registrar Nulo
                    </button>
                )}
                <button onClick={() => setAba('controle')} style={estiloAba(somenteLeitura || aba === 'controle')}>
                    <Sliders size={18} /> Controle
                </button>
            </div>

            <div style={{ paddingTop: 8 }}>
                {conteudo()}
            </div>
        </div>
    );
};

export default Nulos;
